<template>
  <section>

    <b-navbar toggleable="lg" class="submenu">
      <b-nav>
        <add-template>
          <b-nav-item v-b-tooltip.hover :title="$t('TEMPLATES.ADD_TEMPLATE')">
            <i class="fal fa-plus-circle" />
            <span>{{ $t('TEMPLATES.ADD_TEMPLATE') }}</span>
          </b-nav-item>
        </add-template>
        <b-nav-item
          active-class="active"
          :to="{ name: 'Templates.Public' }"
          v-b-tooltip.hover
          :title="$t('TEMPLATES.PUBLISHED')"
        >
          <i class="fal fa-globe" />
          <span>{{ $t('TEMPLATES.PUBLISHED') }}</span>
        </b-nav-item>
        <b-nav-item
          active-class="active"
          :to="{ name: 'Templates.Team' }"
          v-b-tooltip.hover
          :title="$t('TEMPLATES.TEAM')"
        >
          <i class="fal fa-user-friends" />
          <span>{{ $t('TEMPLATES.TEAM') }}</span>
        </b-nav-item>
        <b-nav-item
          active-class="active"
          :to="{ name: 'Templates.Drafts' }"
          v-b-tooltip.hover
          :title="$t('TEMPLATES.DRAFTS')"
        >
          <i class="fal fa-file-edit" />
          <span>{{ $t('TEMPLATES.DRAFTS') }}</span>
        </b-nav-item> 
      </b-nav>
    </b-navbar>

    <div class="container-fluid mt-2">
      <router-view></router-view>
    </div>
      
  </section>
</template>
<script>
import AddTemplate from "@/components/Templates/AddTemplate";
export default {
  components: {
    AddTemplate
  },
  data() {
    return {};
  },
  methods: {},
  mounted: function() {}
};
</script>
<style>
</style>